export default __webpack_public_path__ + "static/media/entrance_15_1.28599a88.png";